import axios from 'axios';
import { DutyHourType } from 'generated';

import { ROSTER_DUTY_HOUR_TYPES } from 'RestAPIs/endpoints';

interface GetRosterDutyHourTypesOptions {
  startDate: string;
  endDate: string;
}

export const getRosterDutyHourTypes = ({
  startDate,
  endDate
}: GetRosterDutyHourTypesOptions) =>
  axios.get<DutyHourType[]>(ROSTER_DUTY_HOUR_TYPES, {
    params: {
      startDate,
      endDate
    }
  });
